'use strict';

angular.module('programme')

.component('articlePageNav', {
    controller: 'ArticlePageNavCtrl',
    templateUrl: 'modules/programme/components/articlePageNav.html',
    bindings: {
        pages: '<',
        currentPage: '<'
    }
})

.controller('ArticlePageNavCtrl', function ()
{
});

